export default __webpack_public_path__ + "static/DaveKyle-64c67e05a0150131bb61a1b84d79c3c3.png";